import { useEffect, useState } from 'react';
import './css/Style.css';
import { SideMenu } from '../../../components/SideMenu';
import { FooterSiteV1 } from '../../../components/FooterSite/v1';
import { NavBarSiteV1 } from '../../../components/NavBarSite/_v1/Index';
import { LINKS_CATARSE, LINKS_WHATSAPP } from '../../../Links';

function Crescer({ Titulo, BackPage }) {
    const [state, setState] = useState(false);
    useEffect(() => {
        if (!state) {
            setState(true);
            return;
        }
        // window.scrollTo({ top: 0, behavior: 'instant' });
    }, [state])
    const [copyMessage, setCopyMessage] = useState('');

    const copyToClipboard = () => {
        navigator.clipboard.writeText('toome@tonomercado.com.br');
        setCopyMessage('Chave Pix copiada!');
        setTimeout(() => setCopyMessage(''), 3000);
    };

    const [showTopics, setShowTopics] = useState(false);
    const handleToggle = () => {
        setShowTopics(!showTopics);
    };


    return (
        <>
            <NavBarSiteV1 />
            <main className='container_geral_toome_crescer'>
                <section className="apoio-section">
                    <div className="apoio-container">
                        <div className='cell'>
                            {window.screen.width > 500
                                ? <img
                                    src={require('./img/1.avif')}
                                    alt="Imagem desktop de colaboração"
                                    loading='lazy'
                                    width={880}
                                    height={520}
                                />
                                : <span><img
                                    src={require('./img/2.avif')}
                                    alt="Imagem mobile de colaboração"
                                    loading='lazy'
                                    width={500}
                                    height={342}
                                /></span>
                            }
                        </div>
                        <h2>🚀 Seja um apoiador ou patrocine o <span>TooMe!</span></h2>

                        <p>
                            O TooMe busca parcerias com <b>empresas de tecnologia</b>, <b>marcas</b> e pessoas que acreditam em inovação com propósito. Ao <b>apoiar ou patrocinar financeiramente</b>, você contribui diretamente para o desenvolvimento, aprimoramento e divulgação do aplicativo, além de ajudar o TooMe a chegar mais rapidamente a <b>outras cidades</b>.
                            Além disso, ajuda a viabilizar funcionalidades que geram economia real e promovem sustentabilidade no dia a dia das compras.
                        </p>

                        {/* <div className="cta-box" style={{ backgroundColor: 'var(--cor_tooMe)' }}>
                            <h3>🚀 Apoie o TooMe e acelere a economia no supermercado</h3>
                            <p>Seu apoio viabiliza o desenvolvimento do app e acelera a liberação do TooMe em novas cidades.</p>
                            <br />
                            <a href={LINKS_CATARSE} target='blank' className="apoio-btn">Contribua pelo CATARSE</a>
                        </div> */}
                        <div className="cta-box" style={{ backgroundColor: 'var(--cor_tooMe)' }}>
                            <h3>🚀 Apoie o TooMe e acelere a economia no supermercado</h3>
                            <p>Seu apoio viabiliza o desenvolvimento do app e acelera a liberação do TooMe em novas cidades.</p>
                            <br />
                            <a onClick={() => {
                                document.getElementById('pix')?.scrollIntoView({
                                    behavior: 'smooth'
                                });
                            }} className="apoio-btn">Faça sua contribuição</a>
                        </div>

                        <div className="apoio-beneficios">
                            <div className="beneficio-card">
                                <h3>🌟 Visibilidade e Reconhecimento</h3>
                                <p>Você ou a sua marca será associada a um projeto de impacto real. Além disso, sua marca contará com destaque em um espaço especial dentro da plataforma.</p>
                            </div>
                            <div className="beneficio-card">
                                <h3>📲 Evolução Contínua</h3>
                                <p>Seu patrocíneo vai viabilizar melhorias constantes: novas funções, tecnologia e chegar mais rapidamente a outras cidades.</p>
                            </div>
                            <div className="beneficio-card">
                                <h3>📈 Alcance e Engajamento</h3>
                                <p>Esteja presente no cotidiano de milhares de usuários que confiam no TooMe para economizar.</p>
                            </div>
                            <div className="beneficio-card">
                                <h3>🌎 Responsabilidade Social</h3>
                                <p>Ajude a combater a desigualdade com informação acessível para todas as classes sociais, principalmente as classes C, D e E.</p>
                            </div>
                            <div className="beneficio-card">
                                <h3>💡 Incentivo à Inovação</h3>
                                <p>Mostre que sua marca apoia ideias criativas e soluções tecnológicas para problemas reais do dia a dia.</p>
                            </div>
                            <div className="beneficio-card">
                                <h3>🤝 Fortalecimento de Comunidade</h3>
                                <p>Conecte-se com consumidores conscientes e com instituições que também buscam um impacto positivo.</p>
                            </div>
                        </div>

                        <section className="apoie-cards-section">
                            <h3>Outras formas de apoiar o TooMe 🤝</h3>
                            <div>
                                <div>
                                    <div className="apoie-icon">🧑‍🤝‍🧑</div>
                                    <p>Indique o TooMe para amigos e familiares.</p>
                                </div>
                                <div>
                                    <div className="apoie-icon">🛒</div>
                                    <p>Poste ofertas no mural colaborativo.</p>
                                </div>
                                <div>
                                    <div className="apoie-icon">💡</div>
                                    <p>Envie sugestões de melhorias pelo app.</p>
                                </div>
                                <div>
                                    <div className="apoie-icon">📱</div>
                                    <p>Compartilhe o TooMe nas redes sociais.</p>
                                </div>
                            </div>
                        </section>

                        <div className='pix' id='pix'>
                            <div>
                                <p>Faça um pix e apoie o desenvolvimento.</p>
                                <div>Scaneie o Qr Code ou copie a  chave pix:
                                    <b> toome@tonomercado.com.br &nbsp;
                                        <button onClick={copyToClipboard} aria-label='Icone de copiar'>
                                            <i className='fa_copy'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</i>
                                        </button>
                                        {copyMessage && <p className="copy-message">{copyMessage}</p>}
                                    </b>
                                </div>
                            </div>
                            <img
                                src={require('./img/qrcode.png')}
                                loading='lazy'
                                width={250}
                                height={251}
                                alt="QR Code para Pix"
                            />
                            <p>Com a sua ajuda, o TooMe vai mais longe!</p>
                        </div>

                        <section className='sustentabilidade'>
                            <div className='sessao_marca_sustentabilidade'>
                                <div>
                                    <h2><u>Sustentabilidade:</u></h2>
                                    <div>
                                        <img
                                            src={require('./img/sust.avif')}
                                            loading='lazy'
                                            width={304}
                                            height={304}
                                            alt='Imagem ilustrativa de sustentabilidade'
                                        />

                                        <p>Atuamos nas três dimensões da sustentabilidade e contribuimos para diversos Objetivos de Desenvolvimento Sustentável (ODS). O TooMe foi projetado para atender a todos, principalmente as classes C, D e E, grupos que mais precisam de ferramentas de economia. Além disso, os dados gerados podem auxiliar governos e instituições na formulação de políticas públicas.</p>

                                    </div>
                                </div>
                            </div>

                            <div className='sessao_sustentabilidade_geral'>

                                <p>Impacto Positivo</p>

                                <section className='sessao_sustentabilidade'>
                                    <p>Além de engajar os clientes em causas sustentáveis, você também fará parte disso.  </p>

                                    <div>
                                        <p onClick={handleToggle} className='GLOBAL_PC_MOUSE_HOVER'>Entenda o impacto &nbsp;<b>🔻</b></p>
                                        {showTopics && (
                                            <div>

                                                <ul>

                                                    <li><b>Desigualdade e Acesso a Bens Essenciais:</b> Com a transparência de preços proporcionada pelo TooMe, os consumidores têm acesso rápido, fácil e igualitário às melhores ofertas de produtos essenciais. Dessa forma, o aplicativo contribui para a redução dos gastos familiares, facilita o acesso a bens indispensáveis e colabora para a diminuição da desigualdade, beneficiando especialmente as pessoas em situação de vulnerabilidade financeira.</li>

                                                    <li><b> Geração de Informações Essenciais:</b> Ao utilizar o TooMe, padrões de buscas e consumo são analisados, e essas são
                                                        informações valiosas para formulação de políticas públicas, ajudando governos e organizações a formularem estratégias eficazes de <b>combate à
                                                            pobreza e a desigualdade.</b></li>

                                                    <li><b>Economia de Dinheiro:</b> Com o compartilhamento de ofertas no mural e a opção padrão de busca de preços, todos economizam, principalmente as
                                                        famílias de baixa renda e os mais vulneráveis.</li>

                                                    <li><b>Economia de Tempo:</b> Com o planejamento de compras baseado nos preços e promoções disponíveis, haverá
                                                        uma
                                                        redução no tempo gasto nas buscas, permitindo que os usuários dediquem mais tempo
                                                        à sua saúde, lazer e bem-estar.</li>

                                                    <li><b>Redução do Desperdício Alimentar:</b> O TooMe está desenvolvendo uma sinalização das ofertas com produtos próximos à data de
                                                        validade, contribuindo para a diminuição da quantidade de alimentos descartados.</li>

                                                    <li><b>Educação Financeira e Conscientização:</b> A exibição de preços de múltiplos supermercados permite escolhas de compra mais informadas e conscientes. Além disso, o TooMe conta com jogos educativos que promovem a educação financeira de forma acessível e interativa.</li>

                                                    <li><b>Apoio à Economia Circular:</b> Ao detectar uma possível compra no supermercado e também de forma
                                                        regular, o TooMe terá notificações com informações sobre reciclagem e reaproveitamento de
                                                        embalagens, promovendo práticas de economia circular entre os consumidores.</li>

                                                    <li><b>Redução do Uso de Papel:</b> Com o recebimento de ofertas e encartes geolocalizados ao se aproximar de um supermercado, os folhetos físicos tornam-se cada vez mais desnecessários. Cada encarte impresso que deixa de circular representa uma redução de 15g de carbono no planeta. Simples assim.</li>

                                                    <li><b>Menor Pegada de Carbono:</b> O planejamento de compras com base em ofertas e promoções de forma
                                                        organizada, reduz a necessidade de múltiplas idas ao supermercado e promove a combinação de compras
                                                        coletivas, diminuindo a emissão de carbono.</li>

                                                </ul>
                                            </div>
                                        )}
                                    </div>

                                </section>
                            </div>
                        </section>

                        <div className="cta-box">
                            <h3>🚀 Torne-se uma marca parceira ou patrocinador oficial</h3>
                            <p>Faça parte da transformação no setor de consumo com um app que conecta, economiza e gera impacto.</p>
                            <a href={LINKS_WHATSAPP} target='blank' className="apoio-btn">Quero ser um parceiro</a>
                        </div>

                        <div className="faq-box">
                            <h3 className="subtitulo">Dúvidas frequentes</h3>
                            <details>
                                <summary>Quem pode patrocinar ou apoiar o TooMe?</summary>
                                <p>Pessoas físicas, empresas de tecnologia e de diversos setores, especialmente dos ramos alimentício, instituições de ensino, startups, organizações do terceiro setor, fintechs e marcas alinhadas com causas sociais e com o empoderamento do consumidor.</p>

                            </details>
                            <details>
                                <summary>Como o patrocínio aparece para os usuários?</summary>
                                <p>Por meio de banners, encartes patrocinados, notificações e presença em áreas exclusivas do app.</p>
                            </details>
                            <details>
                                <summary>Quais as modalidades de apoio?</summary>
                                <p>💰 Patrocínio Direto: Contribuição financeira para projetos específicos, com reconhecimento de marca e exposição estratégica.</p>
                                <p>🎁 Doação de Recursos: Fornecimento de equipamentos, materiais ou serviços que agreguem valor às nossas iniciativas.</p>
                                <p>📊 Apoio com Dados e Pesquisa: Colaboração com instituições de ensino ou empresas para análise de dados, insights de comportamento do consumidor ou desenvolvimento de políticas públicas.</p>
                                <p>🤝 Parceria de Crescimento: Apoio mútuo por meio de colaboração em ações de marketing, parceria tecnológico, co-criação de funcionalidades ou presença institucional em eventos.</p>
                            </details>
                            <details>
                                <summary>Como posso apoiar o TooMe sendo pessoa física?</summary>
                                <p>Você pode apoiar com paceria tecnológica ou pode contribuir com qualquer valor via Pix, indicar o app a outras pessoas, compartilhar nas redes sociais ou enviar sugestões e ofertas pelo aplicativo.</p>
                            </details>

                            <details>
                                <summary>O apoio financeiro tem valor mínimo?</summary>
                                <p>Não! Toda contribuição é bem-vinda e faz a diferença, independentemente do valor. Você apoia o desenvolvimento e expansão do TooMe.</p>
                            </details>

                            <details>
                                <summary>Minha empresa pode receber benefícios ao patrocinar?</summary>
                                <p>Sim! Oferecemos reconhecimento público, inserções da marca, visibilidade no app e associação à causa de economia, inovação e impacto social.</p>
                            </details>

                            <details>
                                <summary>Sou de uma escola ou universidade, como posso colaborar?</summary>
                                <p>Podemos estabelecer parcerias para projetos, pesquisas, programas de extensão ou eventos que envolvam inovação, consumo consciente e tecnologia.</p>
                            </details>

                            <details>
                                <summary>Quais são as formas de contribuição disponíveis?</summary>
                                <p>Pix, patrocínio direto, doação de recursos, parcerias estratégicas e tecnológicas, divulgação voluntária e engajamento nas funcionalidades do aplicativo.</p>
                            </details>

                            <details>
                                <summary>Como posso entrar em contato para propor uma parceria?</summary>
                                <p>Basta nos enviar uma mensagem pelo próprio aplicativo, e-mail ou redes sociais. Estamos abertos a parcerias com propósito e impacto real. Se preferir, você pode <a href={LINKS_WHATSAPP} target='blank'>entrar em contato</a> diretamente conosco.</p>
                            </details>

                            <details>
                                <summary>Como o dinheiro arrecadado será utilizado?</summary>
                                <p>O valor será direcionado ao desenvolvimento de novas funcionalidades, melhorias contínuas, manutenção da plataforma e ações de divulgação.</p>
                            </details>

                        </div>

                    </div>
                </section>

                <SideMenu></SideMenu>
                <FooterSiteV1 />

            </main >

        </>
    )
}

export default Crescer;